export default __webpack_public_path__ + "static/O0012-c5f6867c29e3c3e9e68a83ae917af478.png";